import React from "react";

import { IncodeProvider } from "./IncodeContext";
import { Router } from "./Router";

interface Props {
  interviewId: string;
  vendorToken: string;
  onComplete: Function;
  userId: string;
}

export const IncodeDocumentCapture: React.FunctionComponent<Props> = ({
  userId,
  interviewId,
  vendorToken,
  onComplete,
}) => (
  <IncodeProvider userId={userId} interviewId={interviewId} vendorToken={vendorToken} onComplete={onComplete}>
    <Router />
  </IncodeProvider>
);
